import React, { useState } from "react";
import { Link } from "react-router-dom";
import ForgotUserName from "./ForgotUserName";

const ForgotValidID = () => {
  const [forgotUser, setForgotUser] = useState(false);
  const [forgotMain, setForgotMain] = useState(true);
  const [, setContactAdmin] = useState(false);

  const handleUserName = () => {
    setForgotUser(true);
    setForgotMain(false);
  };

  const handleBackUser = () => {
    setForgotMain(true);
    setForgotUser(false);
  };

  // eslint-disable-next-line no-unused-vars
  const handleContactAdmin = () => {
    setContactAdmin(true);
    setForgotMain(false);
  };

  // eslint-disable-next-line no-unused-vars
  const handleContactBack = () => {
    setForgotMain(true);
    setContactAdmin(false);
  };

  return (
    <div className="login-page">
      <div className="login-shell forgot-valid-shell">
        <section className="login-hero" aria-label="Valid ID recovery overview">
          <div className="login-brand-mark">
            <img alt="WorkFINITY" src="/assets/Img/logo_ft.png" />
          </div>
          <p className="login-kicker">Account Recovery</p>
          <h1>Recover your Valid ID</h1>
          <p className="login-copy">
            Use your registered account information to verify your identity and retrieve the Valid ID connected to your portal access.
          </p>
          <div className="login-highlights" aria-label="Recovery steps">
            <span>Verify identity</span>
            <span>Security check</span>
            <span>Retrieve ID</span>
          </div>
        </section>

        <section className="login-panel" aria-label="Forgot Valid ID">
          <div className="login-card forgot-valid-card">
            {forgotMain && (
              <React.Fragment>
                <div className="login-card-header">
                  <Link to="/Login" className="btn btn-link btn-sm login-back">
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    Back
                  </Link>
                  <p className="login-step-label">Forgot Valid ID?</p>
                  <h2>Let us find it</h2>
                  <p>
                    Start recovery and we will guide you through the security steps required to locate your Valid ID.
                  </p>
                </div>
                <button
                  className="btn w-100 forgot-valid-primary"
                  onClick={handleUserName}
                >
                  <i className="fa fa-search mr-2" aria-hidden="true"></i>
                  I Forgot My Valid ID
                </button>
                <div className="login-support">
                  Need help?{" "}
                  <a href="mailto:Support@workfinity.com">
                    Support@workfinity.com
                  </a>
                </div>
              </React.Fragment>
            )}

            {forgotUser && (
              <div className="forgot-valid-recovery">
                <ForgotUserName
                  handleBackUser={handleBackUser}
                  forgotType="Valid ID"
                ></ForgotUserName>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ForgotValidID;
